import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a96cb14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "largeim" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/statics/images/test/test18.jpg" })
], -1))
const _hoisted_3 = {
  class: "title",
  style: {"text-align":"left"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1))
const _hoisted_5 = { class: "comment" }
const _hoisted_6 = {
  class: "row justify-content-between",
  style: {"white-space":"pre-line","word-wrap":"break-word","text-align":"left","word-break":"break-all"}
}
const _hoisted_7 = { class: "comment-cont" }
const _hoisted_8 = { class: "comment-logo" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "col-md-6 item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "item-top-plus",
  src: "statics/ll/img/plus.png"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "item-top-reduce",
  src: "statics/ll/img/reduce.jpg"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-content-img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "" })
], -1))
const _hoisted_15 = { class: "item-content-word" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.show ? "国际合作" : "International Cooperation"), 1),
      _hoisted_4,
      _withDirectives(_createElementVNode("p", null, " Dehaa Rossun研究中心始终立足于消费者，不断加强产品的研究与开发，与国内外研究机构和专业院校合作，保持着创新的旺盛动力，在原料、设备、产品上寻找突破，旨在为消费者提供更高品质更舒适的产品。 ", 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.internationalCooperationData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-6",
            key: index,
            style: _normalizeStyle(
            item.title == 'OEKO-TEX® STANDARD 100 认证'||item.title == 'STANDARD 100 by OEKO-TEX®' ? 'display:none;' : ''
          )
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: 
                  _ctx.url +
                  '/' +
                  item.pictureAttachment.filePath +
                  '/' +
                  item.pictureAttachment.id +
                  item.pictureAttachment.suffix
                
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("h5", null, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", {
              style: {"text-align":"justify"},
              innerHTML: item.content
            }, null, 8, _hoisted_10)
          ], 4))
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "item-top first",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show1()))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.show ? "OEKO-TEX® STANDARD 100 认证" : "STANDARD 100 by OEKO-TEX®"), 1),
            _hoisted_12,
            _hoisted_13
          ]),
          _createElementVNode("ul", {
            class: "second",
            style: _normalizeStyle(_ctx.type ? '' : 'display: none')
          }, [
            _createElementVNode("li", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.internationalCooperationData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item-content",
                  key: index,
                  style: _normalizeStyle(
                  item.title == 'OEKO-TEX® STANDARD 100 认证'||item.title == 'STANDARD 100 by OEKO-TEX®'
                    ? ''
                    : 'display:none;'
                )
                }, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h5", null, _toDisplayString(item.title), 1),
                    _createElementVNode("img", {
                      alt: "",
                      src: 
                      _ctx.url +
                      '/' +
                      item.pictureAttachment.filePath +
                      '/' +
                      item.pictureAttachment.id +
                      item.pictureAttachment.suffix
                    ,
                      style: {"width":"365px","height":"148px"}
                    }, null, 8, _hoisted_16),
                    _createElementVNode("div", {
                      style: {"text-align":"justify"},
                      innerHTML: item.content
                    }, null, 8, _hoisted_17)
                  ]),
                  _hoisted_18
                ], 4))
              }), 128))
            ])
          ], 4)
        ])
      ])
    ])
  ]))
}